import moment from 'moment';
// import { Logger } from 'aws-amplify';

export const MAX_DATE = '2100-01-01';
export const MIN_DATE = '1900-01-01';
export const DEFAULT_DATE_FORMAT = 'MM/DD/YYYY';
export const dateRegExp =
  /^(0\d{1}|1[0-2])\/([0-2]\d{1}|3[0-1])\/(19|20)\d{2}$/;
export const dateTimeRegExp =
  /^\d{2}\/\d{2}\/\d{4}\s*(?:\d{2}:\d{2}(?::\d{2})?)?$/;

export function treatAsUTC(date: Date) {
  const result = new Date(date);
  result.setMinutes(result.getMinutes() - result.getTimezoneOffset());
  return result;
}

export function formatDate(dateStr: string, dateFormat: string) {
  const date = dateStr.toString().includes('/')
    ? moment(dateStr, DEFAULT_DATE_FORMAT)
    : moment.utc(dateStr);
  let ourDateFormat = dateFormat;
  if (
    ourDateFormat === undefined ||
    ourDateFormat === '' ||
    ourDateFormat === ''
  ) {
    ourDateFormat = DEFAULT_DATE_FORMAT;
  }
  return date.format(ourDateFormat);
}

export function getLocalFormattedDate(format: string) {
  const curDate = moment(treatAsUTC(new Date()));
  return curDate.format(format);
}

export function graphqlDateFormat(dateStr: string) {
  return formatDate(dateStr, 'YYYY-MM-DD');
}
